let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("9RNyM")).then(() => parcelRequire('4nUxR'));